module.exports = __webpack_public_path__ + "img/gc_country_flag_hr.c80e57da.svg";